var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"w-full"},_vm._l((_vm.items),function(item,i){return _c('li',{key:i,staticClass:"flex justify-between w-full border-b border-gray-400 py-5"},[_vm._t("default",null,{"item":item,"index":i})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }